import { Table } from 'app/components/table/table';
import { AggregrationType, ITableColumn, TableModel } from 'app/components/table/table.model';
import { useStore } from 'app/context';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { MultiGpVM } from 'app/stores/ui/agt.multigp.ui.store';
import { Button } from 'app/components/common/Button';
import { notify } from 'app/components/common/notify';
import { formatNum } from 'app/utils';

export const MultiGp2026 = observer(() => {
	const { berichteUiiStore, agtMultiGpUiStore } = useStore();
	const [hasItems, setHasItems] = useState(false);


	const tm = new TableModel<MultiGpVM, number>();
	const cols: ITableColumn<MultiGpVM, number>[] = [];

	cols.push({
		label: 'VD',
		path: 'vd',

	});
	cols.push({
		label: 'basis',
		path: 'gupMin25Base',
		format: formatNum,
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],

	});
	cols.push({
		label: 'gupThreshold1',
		path: 'gupThreshold1',
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],

	});
	cols.push({
		label: 'gupThreshold2',
		path: 'gupThreshold2',
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],

	});
	cols.push({
		label: 'gupMonthsPassing1',
		path: 'gupMonthsPassing1',
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],

	});
	cols.push({
		label: 'gup Ziel 1',
		path: 'gupZiel1',
		render: () => <>8</>


	});
	cols.push({
		label: 'gupMonthsPassing2',
		path: 'gupMonthsPassing2',
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],

	});

	cols.push({
		label: 'gup Ziel 2',
		path: 'gupZiel2',
		render: () => <>8</>

	});

	cols.push({
		label: 'smBase',
		path: 'smBase',
		format: formatNum,
		cellModifier: 'border-left-green bg-green',
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],

	});
	cols.push({
		label: 'smErgebnis',
		path: 'smErgebnis',
		format: formatNum,
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],

	});
	cols.push({
		label: 'smZiel1',
		path: 'smZiel1',
		format: formatNum,
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],

	});
	cols.push({
		label: 'smZiel2',
		path: 'smZiel2',
		format: formatNum,
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],

	});


	cols.push({
		label: 'akumaCount',
		path: 'akumaCount',
		format: formatNum,
		cellModifier: 'border-left-green bg-green',
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],
	});

	cols.push({
		label: 'prime Count',
		path: 'isCurrentAkumaPrimeUserGpCount',
		format: formatNum,
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],
	});

	cols.push({
		label: 'planer Count',
		path: 'akumaPlanerGpCount',
		format: formatNum,
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],
	});
	cols.push({
		label: 'planer count alle',
		path: 'akumaPlanerGpCountDebug',
		format: formatNum,
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],
	});
	cols.push({
		label: 'akumaBase',
		path: 'akumaBase',
		format: formatNum,
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],
	});

	cols.push({
		label: 'akumaZiel',
		path: 'akumaZiel',
		format: formatNum,
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],
	});

	cols.push({
		label: 'leadnowCount',
		path: 'leadnowCount',
		format: formatNum,
		cellModifier: 'border-left-green bg-green',
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],
	});

	cols.push({
		label: 'leadnowAgtOnlyCount',
		path: 'leadnowAgtOnlyCount',
		format: formatNum,
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],
	});
	cols.push({
		label: 'leadnowZiel1',
		path: 'leadnowZiel1',
		format: formatNum,
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],
	});
	cols.push({
		label: 'leadnowZiel2',
		path: 'leadnowZiel2',
		format: formatNum,
		agg: [
			{
				aggType: AggregrationType.sum,
			},
		],
	});




	tm.sortBy = 'vd';
	tm.setCols(cols);


	tm.idProperty = 'agtId';
	tm.idType = 'number';


	useEffect(() => {
		agtMultiGpUiStore.load().then(() => {
			let items = agtMultiGpUiStore.items;

			setHasItems(items.length > 0);
			tm.setRowData(items);
			tm.sort();
		});
	}, [tm, berichteUiiStore.selectedAgt, agtMultiGpUiStore.items]);

	const saveGup = () => {
		agtMultiGpUiStore.saveGup().then(() => {
			notify('GUP gespeichert');
		});
	}

	const saveSm = () => {
		agtMultiGpUiStore.saveSm().then(() => {
			notify('SM gespeichert');
		});
	}

	const saveAkuma = () => {
		agtMultiGpUiStore.saveAkuma().then(() => {
			notify('SM gespeichert');
		});
	}

	const saveLeadNow = () => {
		agtMultiGpUiStore.saveLeadNow().then(() => {
			notify('LeadNow gespeichert');
		});
	}


	return (
		<>
			{!hasItems ? (
				<div className="pad-1rem">Keine Daten gefunden</div>
			) : (
				<>
					<Button type='button' onClick={saveGup}>Save GUP</Button>
					<Button type='button' onClick={saveSm}>Save SM</Button>
					<Button type='button' onClick={saveAkuma}>Save Akuma</Button>
					<Button type='button' onClick={saveLeadNow}>Save LeadNow</Button>
					<Table stickyHeader={true} tm={tm} allowCsvExport={true} csvExportName="multi-gp-2026.csv"></Table>
				</>
			)}
		</>
	);
});
